import performRequest from '@/utils/request';
import { requestEndpoint } from '@/constants/urls';

const workspace = (code) => performRequest({
  url: `${requestEndpoint(code)}/workspace`,
  method: 'GET',
});

const RequestWorkspaceService = {
  workspace,
};

export default RequestWorkspaceService;
